<template>
  <div>
    <b-row align-h="center">
      <h2 class="product__title">Part Details</h2>
      <b-table striped hover :items="part"></b-table>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { load_contract } from '../utils/init'

export default {
  components: {},
  computed: {
    ...mapState(['contracts'])
  },
  async mounted() {
    const accounts = sessionStorage.getItem('address')

    const contracts = await load_contract()
    let result = await contracts.Proxy.methods
      .parts(this.$route.params.partid)
      .call({ from: accounts })

    if (!result) return
    const { mfgTimeStamp, cost, partNumber, serialNumber, supplier } = result

    let supplierDetails = await contracts.Implementation.methods
      .getParticipantDetails(supplier)
      .call({ from: accounts })

    if (!supplierDetails) return

    const dat = new Date(mfgTimeStamp * 1000)

    let formatted_date =
      dat.getMonth() +
      1 +
      '-' +
      dat.getDate() +
      '-' +
      dat.getFullYear() +
      ' ' +
      dat.getHours() +
      ':' +
      dat.getMinutes() +
      ':' +
      dat.getSeconds()

    this.part.push({
      id: this.$route.params.partid,
      cost,
      partNumber,
      serialNumber,
      SupplierAddress: supplier,
      SupplierName: supplierDetails[2],
      Date: formatted_date
    })
  },
  data() {
    return {
      part: [],
      address: ''
    }
  },
  methods: {
    submit: async function() {}
  }
}
</script>

<style scoped>
.col-lg-12.root {
  padding: 20px 50px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 7px 23px #88888852;
  border-radius: 12px;
}

.product__title {
  margin: 20px 0 30px 0;
}

.product__details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.product__header {
  padding-bottom: 5px;
  border-spacing: 2rem;
  border-bottom: 2px solid black;
}

.product__description {
  margin: 10px 0;
}
</style>
